import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { resetTagFocus } from '.';
export var useTagRefocus = function useTagRefocus(_ref) {
  var stateValue = _ref.stateValue,
      isMulti = _ref.isMulti,
      inputRef = _ref.inputRef;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      tagDeleteRefs = _useState2[0],
      setTagDeleteRefs = _useState2[1];

  var focusOnInput = function focusOnInput() {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  var refocus = function refocus(deletedIndex) {
    resetTagFocus({
      refs: tagDeleteRefs,
      deletedIndex: deletedIndex,
      onLastTagDeleted: focusOnInput
    });
  };

  var pushNewTagRef = function pushNewTagRef() {
    setTagDeleteRefs(function (prevRefs) {
      return [].concat(_toConsumableArray(prevRefs), [/*#__PURE__*/React.createRef()]);
    });
  };

  var removeTagRef = function removeTagRef(deletedIndex, isSelectDropdownOpen) {
    if (!isSelectDropdownOpen) {
      refocus(deletedIndex);
    }

    setTagDeleteRefs(function (prevRefs) {
      return prevRefs.filter(function (_, i) {
        return i !== deletedIndex;
      });
    });
  };

  useEffect(function () {
    if (isMulti && Array.isArray(stateValue)) {
      var initialRefs = Array.from({
        length: stateValue.length
      }, function () {
        return /*#__PURE__*/React.createRef();
      });
      setTagDeleteRefs(initialRefs);
    }
  }, [isMulti, stateValue]);
  return {
    tagDeleteRefs: tagDeleteRefs,
    pushNewTagRef: pushNewTagRef,
    removeTagRef: removeTagRef
  };
};